import { t } from "i18next";
import { SkeletonTheme } from "react-loading-skeleton";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import ActionDropwdownCell from "../../shared/components/Table/ActionDropwdownCell";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PaginationState } from "@tanstack/react-table";
import { useAppSelector } from "../../shared/hook";
import Pagination from "../../shared/components/Table/Pagination";
import StatusBadge from "../../shared/Ui/StatusBadge/StatusBadge";
import { format } from "date-fns";
import { Tooltip } from "react-tooltip";
import { Field, Form, Formik } from "formik";
import style from "../ProductCreate/ProductCreate.module.css";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import classNames from "classnames";
import Calendar from "../../shared/Ui/Calendar/Calendar";
import { normalizedLocale } from "../../common/libs/normalizedLocale";
import { useTranslation } from "react-i18next";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";
import { tr } from "date-fns/locale";
import ColorPicker from "../../shared/Ui/ColorPicker/ColorPicker";
import CheckBox from "../../shared/Ui/CheckBox/CheckBox";
import CalendarSelectFormik from "../../shared/Ui/Calendar/CalendarSelectFormik";



function ProductCreate() {
    const navigate = useNavigate();
    const [isMarkOpen, setIsMarkOpen] = useState<any>(null)
    const [createMarkOpen, setCreateMarkOpen] = useState<any>(null)
    const [uploadSertificate, setUploadSertificate] = useState<any>(null)
    const [newPhoto, setNewPhoto] = useState<any>(null)
    const [color, setColor] = useState("#ffffff"); // Начальный цвет
    const data = [
        { id: 1, name: "Новинка", color: "bg-red-500" },
        { id: 2, name: "СЗПТ", color: "bg-green-500" }
    ];
    const [initialValues, setInitialValues] = useState({
        id: "",
        org_id: "generatedOrgId", // ID организации
    });
    const [isOpen, setIsOpen] = useState({
        main: true,
        inditification: false,
        clasification: false,
        sertificates: false,
        photos: false,
        origin: false,
        package: false,
        storage: false,
        characteristics1: false,
        characteristics2: false,
        characteristics3: false,
        characteristics4: false,
        characteristics5: false,
        testGroup: false,
        bioSafe: false,
        himSafe:false
    }
    );
    const toggleSection = (section: keyof typeof isOpen) => {
        setIsOpen(prevState => ({
            ...prevState,
            [section]: !prevState[section]
        }));
    };
    const [selectedLang, setSelectedLang] = useState("ru");
    const languages = {
        ru: "Русский",
        en: "English",
        kz: "Қазақша"
    };
    const [fileName, setFileName] = useState<string | null>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setFileName(event.target.files[0].name);
        }
    };
    const [dataObject, setDataObject] = useState<any>({
        startDate: undefined, // Начальная дата по умолчанию
        startTime: "", // Время для начальной даты по умолчанию
        endDate: undefined, // Конечная дата по умолчанию
        endTime: "", // Время для конечной даты по умолчанию
    });


    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(formikValues) => console.log(123)}
            enableReinitialize={true}
            validateOnBlur={true}
            validateOnChange={true}
        //   validationSchema={formValidationSchema}
        >
            <>
                <ModalComponent
                    isOpen={newPhoto}
                    onClose={() => {
                        setNewPhoto(null);
                    }}
                    content={
                        <div className="flex w-[600px] flex-col gap-[20px]">
                            <span className="font-normal text-[18px]">Загрузка нового файла</span>
                            <div className="flex flex-col gap-[5px]">
                                {newPhoto == 'fileFromBase' ? (
                                    <div className={style.inputField1}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <label className={style.inputLabel}>
                                                Список файлов
                                            </label>
                                        </div>
                                        <Field
                                            component={SelectCustomFormik}
                                            name="refReleaseMethod"
                                            placeholder={t("Выберите")}
                                            size="sm"
                                            isMulti={false}
                                        />
                                    </div>
                                ) : (
                                    <div className="flex flex-col gap-[15px]">
                                        <div className="flex items-center border border-[#a3c0d2] rounded-lg pl-4 py-2 w-full max-h-[40px] ">
                                            <label className="text-gray-500 text-sm flex-grow">
                                                {fileName || "Выберите файл для загрузки"}
                                            </label>
                                            <input
                                                type="file"
                                                onChange={handleFileChange}
                                                className="hidden"
                                                id="file-upload"
                                            />
                                            <label htmlFor="file-upload" className="bg-mainColor text-gray-700  px-4 py-2 rounded-lg cursor-pointer">
                                                Загрузить файл
                                            </label>
                                            {/* <div className="ml-2 bg-gray-200 p-2 rounded-lg">
                                        <img
                                            alt="123"
                                            src="/icons/cloud.svg"
                                            className="cursor-pointer min-w-[20px] w-[20px]"
                                        // onClick={() =>
                                        //     setIsDeleteModalOpen([value?.markId])
                                        // }
                                        ></img>
                                    </div> */}
                                        </div>
                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    {t(
                                                        "Дата до",
                                                    )}
                                                </label>
                                            </div>
                                            <CalendarSelectFormik
                                                dataObject={dataObject}
                                                setDataObject={setDataObject}
                                                onChange={() => {
                                                }}
                                                name="calendar"
                                            />
                                        </div>
                                    </div>
                                )}


                            </div>

                        </div>
                    }
                    customContent={
                        <div className="flex gap-[15px]">
                            <ModalButton
                                type="button"
                                color='grey'
                                onClick={() => {
                                    setNewPhoto(null)
                                }}
                            >
                                Закрыть
                            </ModalButton>
                            <ModalButton
                                type="button"
                                color='mainColor'
                                onClick={() => {
                                    setUploadSertificate(null);
                                }}
                            >
                                Сохранить
                            </ModalButton>
                        </div>

                    }
                />


                <ModalComponent
                    isOpen={uploadSertificate}
                    onClose={() => {
                        setUploadSertificate(null);
                    }}
                    content={
                        <div className="flex w-[600px] flex-col gap-[20px]">
                            <span className="font-normal text-[18px]">Прикрепить сертификат</span>
                            <div className="flex flex-col gap-[5px]">
                                <div className={style.inputField1}>
                                    <div className={style.labelAndButtonWrapper}>
                                        <label className={style.inputLabel}>
                                            Торговая марка
                                        </label>
                                    </div>
                                    <Field
                                        component={SelectCustomFormik}
                                        name="refReleaseMethod"
                                        placeholder={t("Выберите")}
                                        size="sm"
                                        isMulti={false}
                                    />
                                </div>
                                <div className="flex items-center border border-[#a3c0d2] rounded-lg pl-4 py-2 w-full max-h-[40px]">
                                    <label className="text-gray-500 text-sm flex-grow">
                                        {fileName || "Выберите файл для загрузки"}
                                    </label>
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        className="hidden"
                                        id="file-upload"
                                    />
                                    <label htmlFor="file-upload" className="bg-mainColor text-gray-700  px-4 py-2 rounded-lg cursor-pointer">
                                        Загрузить файл
                                    </label>
                                    <div className="ml-2 bg-gray-200 p-2 rounded-lg">
                                        <img
                                            alt="123"
                                            src="/icons/cloud.svg"
                                            className="cursor-pointer min-w-[20px] w-[20px]"
                                        // onClick={() =>
                                        //     setIsDeleteModalOpen([value?.markId])
                                        // }
                                        ></img>
                                    </div>
                                </div>
                                <div className={style.inputField1}>
                                    <div className={style.labelAndButtonWrapper}>
                                        <label className={style.inputLabel2}>
                                            {t(
                                                "checks.fromTo",
                                            )}
                                        </label>
                                    </div>
                                    <CalendarSelectFormik
                                        dataObject={dataObject}
                                        setDataObject={setDataObject}
                                        onChange={() => {
                                        }}
                                        name="calendar"
                                    />
                                </div>
                            </div>

                        </div>
                    }
                    customContent={
                        <div className="flex gap-[15px]">
                            <ModalButton
                                type="button"
                                color='grey'
                                onClick={() => {
                                    setUploadSertificate(null);
                                }}
                            >
                                Закрыть
                            </ModalButton>
                            <ModalButton
                                type="button"
                                color='mainColor'
                                onClick={() => {
                                    setUploadSertificate(null);
                                }}
                            >
                                Сохранить
                            </ModalButton>
                        </div>

                    }
                />
                <ModalComponent
                    isOpen={isMarkOpen}
                    onClose={() => {
                        setIsMarkOpen(null);
                    }}
                    content={
                        <div className="flex w-[550px] flex-col">
                            <div className="flex justify-between w-full items-center">
                                <span className="font-normal text-[18px]">Список меток</span>
                                <button
                                    onClick={() => setCreateMarkOpen(true)}
                                    className=" bg-mainColor text-gray-700  font-semibold py-2 px-4 rounded"
                                >
                                    Добавить
                                </button>
                            </div>
                            <div className="overflow-hidden rounded-lg border border-gray-300 w-full mt-[10px]">
                                <table className="w-full">
                                    <thead>
                                        <tr className="bg-gray-100">
                                            <th className="p-3 text-left">
                                                <input type="checkbox" />
                                            </th>
                                            <th className="py-3 text-left">Иконка и название</th>
                                            <th className="p-3 text-left flex justify-end">Действие</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item) => (
                                            <tr key={item.id} className="border-t">
                                                <td className="p-3">
                                                    <input type="checkbox" />
                                                </td>
                                                <td className="p-3">
                                                    <div className="flex items-center gap-2">
                                                        <span className={`w-4 h-4 ${item.color} block rounded-full`} />
                                                        {item.name}
                                                    </div>
                                                </td>

                                                <td className="p-3 gap-2 flex justify-end">
                                                    <img
                                                        src="/icons/setting.svg"
                                                        className="cursor-pointer min-w-[20px]"
                                                    // onClick={() =>
                                                    //     setIsDeleteModalOpen([value?.markId])
                                                    // }
                                                    ></img>
                                                    <img
                                                        src="/icons/trash.svg"
                                                        className="cursor-pointer min-w-[20px]"
                                                    // onClick={() =>
                                                    //     setIsDeleteModalOpen([value?.markId])
                                                    // }
                                                    ></img>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                    customContent={
                        <ModalButton
                            type="button"
                            color='grey'
                            onClick={() => {
                                setIsMarkOpen(null)
                            }}
                        >
                            закрыть
                        </ModalButton>
                    }
                />

                <ModalComponent
                    isOpen={createMarkOpen}
                    onClose={() => {
                        setCreateMarkOpen(null);
                    }}
                    content={
                        <div className="flex w-[700px] flex-col gap-[20px]">

                            <span className="font-normal text-[18px]">Добавить метку</span>
                            <div className={style.inputField1}>
                                <div className={style.labelAndButtonWrapper}>
                                    <label className={style.inputLabel2}>
                                        Наименование метки

                                    </label>
                                    {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                </div>
                                <div className="flex  overflow-hidden">
                                    {/* Выпадающий список языков */}
                                    <select
                                        className="p-2 border-l border-t border-b rounded-[10px]"
                                        value={selectedLang}
                                        onChange={(e) => setSelectedLang(e.target.value)}
                                    >
                                        {Object.entries(languages).map(([key, label]) => (
                                            <option key={key} value={key}>
                                                {label}
                                            </option>
                                        ))}
                                    </select>

                                    {/* Поле ввода для выбранного языка */}
                                    <Field
                                        name={`names.${selectedLang}`}
                                        placeholder="Укажите название"
                                        className="flex-1 p-2"
                                    />
                                </div>
                            </div>
                            <div className="flex justify-between">
                                <div className={style.inputField2}>
                                    <div className={style.labelAndButtonWrapper}>
                                        <label className={style.inputLabel}>
                                            Торговая марка
                                        </label>
                                    </div>
                                    <Field
                                        component={SelectCustomFormik}
                                        name="refReleaseMethod"
                                        placeholder={t("Выберите")}
                                        size="sm"
                                        isMulti={false}
                                    />
                                </div>
                                <div className={style.inputField2}>
                                    <div className={style.labelAndButtonWrapper}>
                                        <label className={style.inputLabel}>
                                            Торговая марка
                                        </label>
                                    </div>
                                    <Field
                                        component={SelectCustomFormik}
                                        name="refReleaseMethod"
                                        placeholder={t("Выберите")}
                                        size="sm"
                                        isMulti={false}
                                    />
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex flex-row gap-4 items-center w-[54%]">
                                    <span>Выберите цвет иконки</span>
                                    <ColorPicker color={color} onChange={setColor} />
                                </div>
                                <div className="flex flex-row gap-4 items-center">
                                    <span>Выберите цвет текста</span>
                                    <ColorPicker color={color} onChange={setColor} />
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex flex-row gap-4 items-center w-[54%]">
                                    <span>Отображать фигуру метки?</span>
                                    <CheckBox />
                                </div>
                                <div className="flex flex-row gap-4 items-center">
                                    <span>Отображать текст метки?</span>
                                    <CheckBox />
                                </div>
                            </div>

                        </div>
                    }
                    customContent={
                        <div className="flex gap-[20px]">
                            <ModalButton
                                type="button"
                                color='grey'
                                onClick={() => {
                                    setCreateMarkOpen(null);
                                }}
                            >
                                закрыть
                            </ModalButton>
                            <ModalButton
                                type="button"
                                color='mainColor'
                                onClick={() => {
                                    setCreateMarkOpen(null);
                                }}
                            >
                                Продолжить
                            </ModalButton>
                        </div>
                    }
                />
                {/* ТУТ СКАЧИВАЮТСЯ ДОКУМЕНТЫ */}

                <div className="flex flex-col w-[100%]">
                    <div className="flex flex-col w-full">
                        <span className="my-3 text-xl font-semibold">
                            {t('submenu.receipts')}
                        </span>
                        <div className="bg-white my-5 p-5 relative rounded-xl shadow-md flex flex-col align-center justify-between w-full gap-[20px]">
                            <div className="flex flex-row justify-between items-center">
                                <span className="text-[18px] font-semibold">Информация о товаре
                                </span>
                                <div className="flex flex-row gap-[15px]">
                                    <button
                                        onClick={() => navigate('/organization')}
                                        className=" bg-bg text-gray-700  font-semibold py-2 px-4 rounded"
                                    >
                                        Назад
                                    </button>
                                    <button
                                        onClick={() => navigate('/organization')}
                                        className=" bg-mainColor text-gray-700  font-semibold py-2 px-4 rounded"
                                    >
                                        Сохранить
                                    </button>
                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("main")}
                                >
                                    <h2 className="text-lg font-semibold">Основное</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.main ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.main ? "max-h-40 overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    {t("Внешние системы")}
                                                </label>

                                            </div>
                                            <Field

                                                component={SelectCustomFormik}
                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}



                                            />
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    {t("Тип товара")}
                                                </label>

                                            </div>
                                            <Field
                                                component={SelectCustomFormik}
                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("inditification")}
                                >
                                    <h2 className="text-lg font-semibold">Идентификация</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.inditification ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.inditification ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Штрих-код
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Наименование товара

                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="flex  overflow-hidden">
                                                {/* Выпадающий список языков */}
                                                <select
                                                    className="p-2 border-l border-t border-b rounded-[10px]"
                                                    value={selectedLang}
                                                    onChange={(e) => setSelectedLang(e.target.value)}
                                                >
                                                    {Object.entries(languages).map(([key, label]) => (
                                                        <option key={key} value={key}>
                                                            {label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Поле ввода для выбранного языка */}
                                                <Field
                                                    name={`names.${selectedLang}`}
                                                    placeholder="Укажите название"
                                                    className="flex-1 p-2"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Артикул
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    Торговая марка
                                                </label>
                                            </div>
                                            <Field
                                                component={SelectCustomFormik}
                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Код ТНВЭД

                                                </label>

                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    Бренд
                                                </label>

                                            </div>
                                            <Field
                                                component={SelectCustomFormik}
                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>Описание продукции</label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    as="textarea"
                                                    name="barcode"
                                                    placeholder="Введите пароль"
                                                    className="w-full h-24 p-2 border rounded-md"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("clasification")}
                                >
                                    <h2 className="text-lg font-semibold">Классификация и позиционирование</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.clasification ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.clasification ? "max-h-40 overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    Категория/подкатегория

                                                </label>
                                                {/* {formik.touched.refReleaseMethod && formik.errors.refReleaseMethod && (
                        <div className={style.tooltipWrapper}>
                          <FaExclamationCircle className={style.errorIcon} />
                          <div className={style.tooltipText}>
                            {typeof formik.errors.refCountryOrigin === "string"
                              ? formik.errors.refCountryOrigin
                              : t("new_order.country_origin_error")}
                          </div>
                        </div>
                      )} */}
                                            </div>
                                            <Field

                                                component={SelectCustomFormik}
                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}



                                            />
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    {t("Тип товара")}
                                                </label>

                                            </div>
                                            <button className="flex items-center gap-2 bg-mainColor text-white font-thin px-4 py-2 rounded-md shadow  transition"
                                                onClick={() => setIsMarkOpen(true)}
                                            >
                                                <span className="flex items-center justify-center w-5 h-5 border-2 border-white rounded-full">
                                                    +
                                                </span>
                                                Добавить/изменить метку
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("sertificates")}
                                >
                                    <h2 className="text-lg font-semibold">Сертификаты</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.sertificates ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={`flex gap-[40px] ${isOpen.sertificates ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >

                                    <div className="mt-[20px] w-40 h-60 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Прекрепить Сертификат соответствия
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setUploadSertificate('Conformity')
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-60 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Прекрепить Сертификат качества
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setUploadSertificate('Quality')
                                                }
                                            ></img>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("photos")}
                                >
                                    <h2 className="text-lg font-semibold">Внешний вид</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.photos ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={`flex flex-wrap gap-[40px] ${isOpen.photos ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >

                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фронт фото
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото 3/4
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото этикетки
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото дополнительный ракурс 1
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото дополнительный ракурс 2
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото дополнительный ракурс 3
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото дополнительный ракурс 4
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото дополнительный ракурс 5
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото ассортимента
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                    <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                        <p className="text-gray-600 text-center mb-4">
                                            Загрузите Фото фасовки
                                        </p>
                                        <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                            <img
                                                src="/icons/download.svg"
                                                className="cursor-pointer min-w-[20px]"
                                                onClick={() =>
                                                    setNewPhoto("newFile")
                                                }
                                            ></img>
                                            <img
                                                src="/icons/cloud.svg"
                                                className="cursor-pointer max-w-[25px]"
                                                onClick={() =>
                                                    setNewPhoto("fileFromBase")
                                                }
                                            ></img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("origin")}
                                >
                                    <h2 className="text-lg font-semibold">Происхождение</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.origin ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.origin ? "max-h-40 overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    {t("Производитель")}
                                                </label>

                                            </div>
                                            <Field

                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}
                                            />
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    {t("Страна происхождения")}
                                                </label>

                                            </div>
                                            <Field
                                                component={SelectCustomFormik}
                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("package")}
                                >
                                    <h2 className="text-lg font-semibold">Упаковка/тара</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.package ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.package ? "max-h-40 overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    {t("Тип упаковки")}
                                                </label>

                                            </div>
                                            <Field
                                                component={SelectCustomFormik}
                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}
                                            />
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    {t("Объем, л")}
                                                </label>

                                            </div>
                                            <Field

                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>
                                                    {t("Новый атрибут*")}
                                                </label>

                                            </div>
                                            <Field

                                                name="refReleaseMethod"
                                                placeholder={t("Выберите")}
                                                size="sm"
                                                isMulti={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("inditification")}
                                >
                                    <h2 className="text-lg font-semibold">Характеристики товара или его свойства</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.inditification ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.inditification ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Сорт
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Состав

                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="flex  overflow-hidden">
                                                {/* Выпадающий список языков */}
                                                <select
                                                    className="p-2 border-l border-t border-b rounded-[10px]"
                                                    value={selectedLang}
                                                    onChange={(e) => setSelectedLang(e.target.value)}
                                                >
                                                    {Object.entries(languages).map(([key, label]) => (
                                                        <option key={key} value={key}>
                                                            {label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Поле ввода для выбранного языка */}
                                                <Field
                                                    name={`names.${selectedLang}`}
                                                    placeholder="Укажите название"
                                                    className="flex-1 p-2"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Единица измерения
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Описание товара

                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="flex  overflow-hidden">
                                                {/* Выпадающий список языков */}
                                                <select
                                                    className="p-2 border-l border-t border-b rounded-[10px]"
                                                    value={selectedLang}
                                                    onChange={(e) => setSelectedLang(e.target.value)}
                                                >
                                                    {Object.entries(languages).map(([key, label]) => (
                                                        <option key={key} value={key}>
                                                            {label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Поле ввода для выбранного языка */}
                                                <Field
                                                    name={`names.${selectedLang}`}
                                                    placeholder="Укажите название"
                                                    className="flex-1 p-2"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("storage")}
                                >
                                    <h2 className="text-lg font-semibold">Условия хранения и поставки</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.storage ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.storage ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Срок годности
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Срок реализации в днях
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Условия хранения

                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="flex  overflow-hidden">
                                                {/* Выпадающий список языков */}
                                                <select
                                                    className="p-2 border-l border-t border-b rounded-[10px]"
                                                    value={selectedLang}
                                                    onChange={(e) => setSelectedLang(e.target.value)}
                                                >
                                                    {Object.entries(languages).map(([key, label]) => (
                                                        <option key={key} value={key}>
                                                            {label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Поле ввода для выбранного языка */}
                                                <Field
                                                    name={`names.${selectedLang}`}
                                                    placeholder="Укажите название"
                                                    className="flex-1 p-2"
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Минимальная температура хранения , °С
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="mt-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Максимальная температура хранения, °С
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("characteristics1")}
                                >
                                    <h2 className="text-lg font-semibold">Весо-габаритные характеристики. Базовая единица измерения</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.characteristics1 ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.characteristics1 ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Длина (глубина), см
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Ширина, см
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Высота, см
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Объем
                                                </label>

                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="flex mt-4 gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес нетто, кг
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>

                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес брутто, кг
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>

                                        </div>

                                    </div>


                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("characteristics2")}
                                >
                                    <h2 className="text-lg font-semibold">Весо-габаритные характеристики. Упаковка первого уровня (блок)</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.characteristics2 ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.characteristics2 ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Признак блочности (Есть/Нет)
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Штрих-код блока
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Кол-во шт. в блоке
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Длина (глубина) блока, см
                                                </label>

                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="flex mt-4 gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Ширина блока, см
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>

                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Высота блока, см
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>

                                        </div>

                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес блока брутто, кг
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Кол-во блоков в коробе
                                                </label>

                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Объем блока
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("characteristics3")}
                                >
                                    <h2 className="text-lg font-semibold">Весо-габаритные характеристики. Упаковка второго уровня (ящик/короб)</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.characteristics3 ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.characteristics3 ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Признак короба (Есть/Нет)
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Штрих-код короба
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Тип короба
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Признак "Нестандартный короб"
                                                </label>

                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="flex mt-4 gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Кол-во шт/кг в коробе
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>

                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Хрупкость короба (от 1 до 10, 1 -очень хрупкий, 10 -антихрупкий)
                                                </label>
                                                {/* {formik.touched.password && formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password === "string"
                                                                ? formik.errors.password
                                                                : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>

                                        </div>

                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес короба брутто, кг
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Высота короба, см
                                                </label>

                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес незаполненного короба, кг
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Ширина короба, см
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Объем короба
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Длина (глубина) короба, см
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("characteristics4")}
                                >
                                    <h2 className="text-lg font-semibold">Весо-габаритные характеристики. Упаковка третьего уровня (слой)</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.characteristics4 ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.characteristics4 ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Кол-во коробов в слое
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Высота слоя, см
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес слоя брутто, кг
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>


                                    </div>

                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("characteristics5")}
                                >
                                    <h2 className="text-lg font-semibold">Весо-габаритные характеристики. Упаковка четвертого уровня (палетта)</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.characteristics5 ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.characteristics5 ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Кол-во коробов на паллете
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Тип паллеты (американка/евро)
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Кол-во шт/кг на паллете
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес поддона, кг
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field

                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Высота паллеты, см
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес паллеты брутто, кг
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("testGroup")}
                                >
                                    <h2 className="text-lg font-semibold">Тестовая группа</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.testGroup ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.testGroup ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex ">
                                        <div className="w-[50%]">
                                            <div className="mt-[20px] w-40 h-40 border-2 border-dashed border-yellow-400 flex flex-col items-center justify-center rounded-md p-4">
                                                <p className="text-gray-600 text-center mb-4">
                                                    Загрузите Фронт фото
                                                </p>
                                                <div className="bg-green-100 p-2 rounded-md flex gap-[15px]">
                                                    <img
                                                        src="/icons/download.svg"
                                                        className="cursor-pointer min-w-[20px]"
                                                        onClick={() =>
                                                            setNewPhoto("newFile")
                                                        }
                                                    ></img>
                                                    <img
                                                        src="/icons/cloud.svg"
                                                        className="cursor-pointer max-w-[25px]"
                                                        onClick={() =>
                                                            setNewPhoto("fileFromBase")
                                                        }
                                                    ></img>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Тип паллеты (американка/евро)
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Кол-во шт/кг на паллете
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>
                                                    Вес поддона, кг
                                                </label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="password"
                                                    placeholder="Введите пароль"
                                                    className="placeholder" // Ваш класс для стилей
                                                />
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("bioSafe")}
                                >
                                    <h2 className="text-lg font-semibold">Параметры биологической безопасности</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.bioSafe ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.bioSafe ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>Гигроскопичность, %, не менее</label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    as="textarea"
                                                    name="barcode"
                                                    placeholder="Введите пароль"
                                                    className="w-full h-24 p-2 border rounded-md"
                                                />
                                            </div>
                                        </div>

                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>Воздухопроницаемость, дм3 /м2 с, не менее</label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    as="textarea"
                                                    name="barcode"
                                                    placeholder="Введите пароль"
                                                    className="w-full h-24 p-2 border rounded-md"
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            <div className="w-full border rounded-lg p-4">
                                {/* Заголовок с кнопкой */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleSection("himSafe")}
                                >
                                    <h2 className="text-lg font-semibold">Параметры химической безопасности</h2>
                                    <svg
                                        className={`w-5 h-5 transition-transform duration-300 ${isOpen.himSafe ? "rotate-180" : "rotate-0"
                                            }`}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </div>

                                {/* Разворачиваемый контент */}
                                <div
                                    className={` ${isOpen.himSafe ? " overflow-visible" : "max-h-0 overflow-hidden"
                                        }`}
                                >
                                    <div className="mt-4 w-full flex gap-4">
                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>Уровень напряженности электростатического поля на поверхности изделия, кВ/м, не более</label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    as="textarea"
                                                    name="barcode"
                                                    placeholder="Введите пароль"
                                                    className="w-full h-24 p-2 border rounded-md"
                                                />
                                            </div>
                                        </div>

                                        <div className={style.inputField2}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel2}>Содержание свободного формальдегида, мкг/г, не более</label>
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    as="textarea"
                                                    name="barcode"
                                                    placeholder="Введите пароль"
                                                    className="w-full h-24 p-2 border rounded-md"
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </>
        </Formik>
    );


}


export default ProductCreate;
